import styled from 'styled-components';

const PageTitle = styled.div`
  display: flex;
  flex-direction: column;

  font-size: 32px;
  width: fit-content;
  padding: 20px;
  align-self: center;
  align-items: center;

  @media (max-width: 800px) {
    font-size: 28px;
  }
`;

export default PageTitle;
